enum Routes {
  Root = '/:uuid',
  Home = '/:uuid/:language',
  ElectionGroup = '/:uuid/:language/:electionGroup',
  Candidate = '/:uuid/:language/:electionGroup/:candidate',
  NoMatch = 'NoMatch'
}

export default Routes;
